import { Format } from 'modules';
import { CERTN_IMAGES_S3 } from 'base/BaseConstants';

export const parseURL = (licenseType, provState) =>
    `${CERTN_IMAGES_S3}/licenses/${Format.codeToCountry(licenseType)}/${Format.provinceCodeToName(provState)}.png`;
